import React from 'react';

function NotificationElement({ content }) {
  const {
    toggleSms,
    toggleEmail,
    toggleInApp,
    handleChangeSms,
    handleChangeEmail,
    handleChangeInApp,
  } = content;
  return (
    <div>
      <h2 className='text-[18px] font-semibold pb-6'>System Settings</h2>
      <div className='border-t-hf flex flex-row gap-4 py-6'>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='28'
          height='28'
          viewBox='0 0 36 36'
          className='text-s-bk'
        >
          <path
            fill='currentColor'
            d='m32.85 28.13l-.34-.3A14.37 14.37 0 0 1 30 24.9a12.63 12.63 0 0 1-1.35-4.81v-4.94A10.81 10.81 0 0 0 19.21 4.4V3.11a1.33 1.33 0 1 0-2.67 0v1.31a10.81 10.81 0 0 0-9.33 10.73v4.94a12.63 12.63 0 0 1-1.35 4.81a14.4 14.4 0 0 1-2.47 2.93l-.34.3v2.82h29.8Z'
            className='clr-i-solid clr-i-solid-path-1'
          />
          <path
            fill='currentColor'
            d='M15.32 32a2.65 2.65 0 0 0 5.25 0Z'
            className='clr-i-solid clr-i-solid-path-2'
          />
          <path fill='none' d='M0 0h36v36H0z' />
        </svg>
        <div className='flex flex-col items-left gap-5 w-full'>
          <h3>Notifications</h3>
          <div className='flex flex-col gap-6 items-center w-full'>
            <div className='flex flex-row justify-between items-center w-full'>
              <p className=' text-s-bk'>SMS notifications</p>
              <div className='flex flex-row items-center gap-2'>
                <label className='text-s-bk text-base font-pin relative'>
                  Off/On
                </label>
                <input
                  type='checkbox'
                  id='hs-medium-switch'
                  className='relative shrink-0 w-[3.25rem] h-7 bg-gray-100 checked:bg-none checked:bg-blue-400 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 ring-1 ring-transparent focus:border-blue-400 focus:ring-blue-400 ring-offset-white focus:outline-none appearance-none dark:bg-s-bk dark:checked:bg-b-mc dark:focus:ring-offset-gray-800 before:inline-block before:w-6 before:h-6 before:bg-white checked:before:bg-blue-200 before:translate-x-0 checked:before:translate-x-full before:shadow before:rounded-full before:transform before:ring-0 before:transition before:ease-in-out before:duration-200 dark:before:bg-p-wh dark:checked:before:bg-blue-200'
                  checked={toggleSms}
                  value={toggleSms}
                  onChange={handleChangeSms}
                />
              </div>
            </div>
            <div className='flex flex-row justify-between items-center w-full'>
              <p className=' text-s-bk'>Email notifications</p>
              <div className='flex flex-row items-center gap-2'>
                <label className='text-s-bk text-base font-pin relative'>
                  Off/On
                </label>
                <input
                  type='checkbox'
                  id='hs-medium-switch'
                  className='relative shrink-0 w-[3.25rem] h-7 bg-gray-100 checked:bg-none checked:bg-blue-400 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 ring-1 ring-transparent focus:border-blue-400 focus:ring-blue-400 ring-offset-white focus:outline-none appearance-none dark:bg-s-bk dark:checked:bg-b-mc dark:focus:ring-offset-gray-800 before:inline-block before:w-6 before:h-6 before:bg-white checked:before:bg-blue-200 before:translate-x-0 checked:before:translate-x-full before:shadow before:rounded-full before:transform before:ring-0 before:transition before:ease-in-out before:duration-200 dark:before:bg-p-wh dark:checked:before:bg-blue-200'
                  checked={toggleEmail}
                  value={toggleEmail}
                  onChange={handleChangeEmail}
                />
              </div>
            </div>
            <div className='flex flex-row justify-between items-center w-full'>
              <p className=' text-s-bk'>In app notifications</p>
              <div className='flex flex-row items-center gap-2'>
                <label className='text-s-bk text-base font-pin relative'>
                  Off/On
                </label>
                <input
                  type='checkbox'
                  id='hs-medium-switch'
                  className='relative shrink-0 w-[3.25rem] h-7 bg-gray-100 checked:bg-none checked:bg-blue-400 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 ring-1 ring-transparent focus:border-blue-400 focus:ring-blue-400 ring-offset-white focus:outline-none appearance-none dark:bg-s-bk dark:checked:bg-b-mc dark:focus:ring-offset-gray-800 before:inline-block before:w-6 before:h-6 before:bg-white checked:before:bg-blue-200 before:translate-x-0 checked:before:translate-x-full before:shadow before:rounded-full before:transform before:ring-0 before:transition before:ease-in-out before:duration-200 dark:before:bg-p-wh dark:checked:before:bg-blue-200'
                  checked={toggleInApp}
                  value={toggleInApp}
                  onChange={handleChangeInApp}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotificationElement;
